export function isLive(url = window?.location?.hostname): boolean {
  return !["localhost", ".local.", ".dev.", ".qa.", ".beta.", "-np."].some(
    env => url.includes(env)
  );
}

export default function insertCc8Header() {
  if (document.querySelector(".cc8navbar")) {
    return;
  }
  const isProd = isLive();
  const domain = isProd
    ? "ddcplatform.dealer.com"
    : "ddcplatform-np.dealer.com";
  let link = document.createElement("link");
  link.setAttribute("async", "true");
  link.setAttribute("rel", "stylesheet");
  link.setAttribute("href", `https://cc8-theme.${domain}/cc8-theme.css`);
  link.className = "cc8navbar";
  document.head.appendChild(link);

  link = document.createElement("link");
  link.setAttribute("async", "true");
  link.setAttribute("rel", "stylesheet");
  link.setAttribute("href", `https://cc8-navbar.${domain}/cc8-navbar.css`);
  document.head.appendChild(link);

  const script = document.createElement("script");
  script.setAttribute("async", "true");
  script.setAttribute("rel", "stylesheet");
  script.setAttribute("src", `https://cc8-navbar.${domain}/cc8-navbar.js`);
  document.head.appendChild(script);

  link = document.createElement("link");
  link.setAttribute("async", "true");
  link.setAttribute("rel", "stylesheet");
  link.setAttribute(
    "href",
    isProd
      ? "https://cc3.dealer.com/cc7/welcome/3.28.35/core/css/ddc.css"
      : "https://cc-static-qa.ddcplatform-np.dealer.com/cc7/welcome/3.28.35/core/css/ddc.css"
  );
  document.head.appendChild(link);
}
